import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { lastValueFrom } from 'rxjs';
import { RestService } from './core/rest.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })

export class ReportService {

  private apiBase = environment.powerBi.apiBase;
  private reportId: string = '';
  private workspaceId: string = '';

  constructor(private http: HttpClient, private rest: RestService) { }

  async exportReport(testId: number, accessToken: string, type: number): Promise<Blob | null> {

    const headers = new HttpHeaders({

      'Authorization': `Bearer ${accessToken}`,

      'Content-Type': 'application/json'

    });
    const configUrl = '/Master/GetReportDetails/' + type; // Replace with your actual endpoint

    const config: any = await lastValueFrom(this.rest.get(configUrl));
    this.reportId = config.reportId;
    this.workspaceId = config.workSpaceId;


    // Step 1: Start export

    const exportUrl = `${this.apiBase}/${this.workspaceId}/reports/${this.reportId}/ExportTo`;
    let body;
    if (type === 1) {
      body = {

        format: 'PDF',

        paginatedReportConfiguration: {

          parameterValues: [

            { name: 'TestId', value: testId }

          ]

        }

      };

    }
    else {
      body = {

        format: 'PDF',

      };

    }

    const exportStartResp: any = await lastValueFrom(

      this.http.post(exportUrl, body, { headers })

    );

    const exportId = exportStartResp.id;

    // Step 2: Poll for export status

    const statusUrl = `${this.apiBase}/${this.workspaceId}/reports/${this.reportId}/exports/${exportId}`;

    let status = '';

    do {

      await new Promise(res => setTimeout(res, 2000));

      const statusResp: any = await lastValueFrom(this.http.get(statusUrl, { headers }));

      status = statusResp.status;

      if (status === 'Failed') {

        throw new Error('Export failed');

      }

    } while (status !== 'Succeeded');

    // Step 3: Download the file

    const fileUrl = `${statusUrl}/file`;

    return await lastValueFrom(

      this.http.get(fileUrl, { headers, responseType: 'blob' })

    );

  }

}




